import React from 'react';
import { useMarqueeAnimation } from '../hooks/gsap/useMarqueeGSAP';
import StarIcon from './StarIcon';
import '../assets/css/marquee.css';

const MarqueeSection = () => {
  useMarqueeAnimation();

  // Every glyph here is covered by TuskerGrotesk. Russian was dropped rather
  // than corrected: the font has no Cyrillic at all, so ВЕРНЁТСЯ would render
  // in the system fallback face. The old "BEPHЁTCЯ" was Latin lookalikes
  // working around the same gap, and still fell back on Ё and Я.
  const marqueeTexts = [
    "BREAKSPOLL WILL RETURN",
    "BREAKSPOLL VOLVERÁ",
    "BREAKSPOLL KOMMT ZURÜCK",
    "BREAKSPOLL POWRÓCI",
  ];

  return (
    <section className="marquee-section section-breakpoint">
      <div className='wrapper'>
        <div className='marquee_container'>
          <div className='marquee_content'>
            {marqueeTexts.map((text, index) => (
              <React.Fragment key={index}>
                <span className='letter'>{text}</span>
                <StarIcon className='marquee-star' />
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MarqueeSection;
